import React, { useEffect, useState } from 'react';
import { Accordion, Collapse } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Services from './../../service';
import { FaPlus, FaMinus } from 'react-icons/fa';

const SidebarCategory = (props) => {
    const { filterBrand } = props;

    const [Categories, setCategories] = useState({})
    const [FixedSidebar, setFidexSidebar] = useState(false)

    const [BrandOpen, setBrandOpen] = useState(true)

    const [SelectedBrand, setSelectedBrand] = useState([])

    useEffect(() => {
        getCategory()

        if (window !== undefined) {
            window.addEventListener('scroll', function () {
                if (window.scrollY > 160) {
                    setFidexSidebar(true)
                } else {
                    setFidexSidebar(false)
                }
            });
        }
    }, [])

    useEffect(() => {
            
        let params = SelectedBrand.length > 0 ? SelectedBrand.toString() : null;
        props.setParams(searchParams => {

            if (params !== null) {
                searchParams.set("brand", params);
            } else if(searchParams.has("brand")) {
                searchParams.delete("brand");
            }

            return searchParams;
        })

    }, [SelectedBrand])

    const getCategory = async () => {
        await Services.GetMainCategories()
            .then((res) => {
            setCategories(res.data.categories)
        }).catch((err) => {
            console.log('error Category Sidebar:', err.response.data)
        })
    }

    const handleBrandChange = (event) => {
        const valueBrand = event.target.value;

        if(event.target.checked){
            setSelectedBrand([...SelectedBrand,valueBrand])
        }else{
            setSelectedBrand(SelectedBrand.filter(value=>value !== valueBrand))
        }
    }

    return (
        // <div className={`bg-white ${FixedSidebar ? 'sidebar-cat-float border' : ''}`}>
        <div className="bg-white">

            {filterBrand &&
                <>
                    <p className="m-0 fs-4 fw-bold has-after text-uppercase p-4">Filter</p>
                    
                    <div className="fliter-collapse-button"
                        onClick={() => setBrandOpen(!BrandOpen)}
                        aria-controls="brand-collapse"
                        aria-expanded={BrandOpen}>
                        {BrandOpen ?  <FaMinus /> : <FaPlus />}
                        <p>Brands</p>
                    </div>
                    <Collapse in={BrandOpen}>
                        <div id="brand-collapse" className="filter-wrapper">
                            {filterBrand && filterBrand.map((item, i) => (
                                <div className="form-check" key={i}>
                                    <input className="form-check-input" type="checkbox" value={item.value} id={item.value} onChange={(e) => handleBrandChange(e)} />
                                    <label className={`form-check-label ${item.name.trim().length <= 3 ? 'text-uppercase' : ''}`} htmlFor={item.value}>
                                        {item.name ? item.name : 'Undefined'} ({item.total_products})
                                    </label>
                                </div>
                            ))}
                        </div>
                    </Collapse>

                    <hr />
                </>
            }

            <p className="m-0 fs-5 fw-bold has-after text-uppercase p-4">Others Category</p>

            <Accordion flush className="accordion-cat-wrapper">

                {Categories.length > 0 && Categories.map((cat, i) => {
                    return (
                        <Accordion.Item eventKey={i} key={i}>

                            {cat.children_categories.length > 0 ? 
                                <>
                                    <Accordion.Header>
                                        <Link to={`/categories/${cat.slug}`}> {cat.name} </Link>
                                    </Accordion.Header>
                                    <Accordion.Body className="child ms-2 p-0">
                                        <Accordion flush className="bg-secondary">

                                            {cat.children_categories.map((child, j) => {
                                                return (
                                                    <Accordion.Item eventKey={j} key={j}>
                                                        
                                                        {child.categories.length > 0 ? 
                                                            <>
                                                                <Accordion.Header>
                                                                    <Link to={"/categories/" + cat.slug + '/' + child.slug}>
                                                                        {child.name}
                                                                    </Link>
                                                                </Accordion.Header>
                                                                <Accordion.Body className="child ms-3 p-0">
                                                                    <Accordion flush className="bg-secondary">
                                                                        {child.categories.map((sc, l) => {
                                                                            return (
                                                                                <Accordion.Item eventKey={l} key={l}>
                                                                                    <Link to={"/categories/" + cat.slug + '/' + child.slug + '/' + sc.slug} className="accordion-button no-child">
                                                                                        {sc.name}
                                                                                    </Link>
                                                                                </Accordion.Item>
                                                                            )
                                                                        })}
                                                                    </Accordion>
                                                                </Accordion.Body>
                                                            </>
                                                            :
                                                            <>
                                                                <Link to={"/categories/" + cat.slug + '/' + child.slug} className="accordion-button no-child">
                                                                    {child.name}
                                                                </Link>
                                                            </>
                                                        }

                                                    </Accordion.Item>
                                                )
                                            })}

                                        </Accordion>
                                    </Accordion.Body>
                                </>
                                :
                                <>
                                    <Link to={`/categories/${cat.slug}`} className="accordion-button no-child"> {cat.name} </Link>
                                </>
                            }
                        
                    </Accordion.Item>
                    )
                })}

            </Accordion>
        </div>
    )
}

export default SidebarCategory
